<template>
  <div @mousewheel="mousewheelHandle" v-if="loading">
    <header-top/>
    <!-- 第一屏 -->
    <first-screen/>
    <!-- 简介 -->
    <page2/>
    <page3/>
<!--    <brief-introduction/>-->
    <!-- 项目 -->
    <home-projects/>
    <!-- team 团队 -->
    <team-introduction/>
    <page5/>
<!--    <our-team/>-->
    <!-- 合作伙伴 -->
    <page6/>
<!--    <cooperate-partner/>-->
    <!-- 联系我们 -->
    <contact-us/>
    <!-- 首页尾部 -->
    <foot-bottom/>
  </div>
</template>

<script>
import BriefIntroduction from "@/views/home/components/brief-introduction.vue";
import page2 from "@/views/home/components/page-2.vue";
import page3 from "@/views/home/components/page-3.vue";
import page5 from "@/views/home/components/page-5.vue";
import page6 from "@/views/home/components/page-6.vue";
import FirstScreen from "@/views/home/components/first-screen.vue";
import HomeProjects from "@/views/home/components/home-projects.vue";
import OurTeam from "@/views/home/components/our-team.vue";
import teamIntroduction from "@/views/home/components/team-introduction.vue";
import CooperatePartner from "@/views/home/components/cooperate-partner.vue";
import ContactUs from "@/views/home/components/contact-us.vue";
import FootBottom from "@/components/foot-bottom.vue";
import key from "@/api/key";
import HeaderTop from "@/components/header-top.vue";

export default {
  name: 'HomeView',
  components: {
    HeaderTop,
    FootBottom,
    HomeProjects,
    FirstScreen,
    BriefIntroduction,
    page2,
    page3,
    page5,
    page6,
    OurTeam,
    teamIntroduction,
    CooperatePartner,
    ContactUs
  },
  data() {
    return {
      showMenu: false,
      options: {
        licenseKey: 'OPEN-SOURCE-GPLv3-LICENSE',
        afterLoad: this.afterLoad,
        scrollOverflow: true,
        scrollBar: false
      },
      loading: false
    }
  },
  methods: {
    // 鼠标滚动事件
    mousewheelHandle(e) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop < clientHeight && e.deltaY > 0) {
        this.jumpToDown()
      }
    },
    jumpToDown() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      window.scrollTo({top: clientHeight, behavior: "smooth"})
    }
  },
  created() {
    const homeList = 'page-2-bg,page-2-video-1,more-services-btn,page-3-bg,view-more-btn,page-5-bg,page-6-bg'
    this.$api.get('H5_home', homeList, key.HOME)

    const homeSwiperList = 'swiper4,swiper5,swiper6'
    this.$api.get('H5_home', homeSwiperList, key.HOME_SWIPER)

    const homeSwiperVideoList = 'swiper-video1,swiper-video2,swiper-video3'
    this.$api.get('H5_home', homeSwiperVideoList, key.HOME_SWIPER_VIDEO)

    // 首页项目
    const homeProjectList = 'projects,projects-2,portfolio,project-art-text,project-art-pic,' +
        'project-com-text,project-com-pic,project-multi-text,project-interactive-video'
    this.$api.get('H5_home', homeProjectList, key.HOME_PROJECT)

    // 首页团队
    const homeTeamList = 'team-view-more,new-team1,' +
        'new-team2,new-team3,new-team4,new-team5,new-team1-title,new-team2-title,new-team3-title,' +
        'new-team4-title,new-team5-title,team-introduction'
    this.$api.get('H5_home', homeTeamList, key.HOME_TEAM)

    // 首页合作品牌
    const homeCooperateList = 'cooperate-title,cooperate-bmw,cooperate-miumiu,cooperate-aecom,cooperate-10086,cooperate-ifs'
    this.$api.get('H5_home', homeCooperateList, key.HOME_COOPERATE)

    // 首页联系我们
    const homeContactList = 'contact-card,contact-arrow-right,contact-us-view-more'
    this.$api.get('H5_home', homeContactList, key.HOME_CONTACT)

    // 产品展示页各类产品视频
    this.$api.get('H5_products', 'art1,art2,art3,art4,art5,art6,art7,art8', key.PROJECTS_VIDEO_ART)
    this.$api.get('H5_products', 'com1,com2,com3,com4,com5,com6', key.PROJECTS_VIDEO_COM)
    this.$api.get('H5_products', 'mult1,mult2,mult3,mult4', key.PROJECTS_VIDEO_MULTI)
    setTimeout(() => {
      this.loading = true
    }, 100);
  },
  metaInfo: {
    title: "U-cute Lab",
    meta: [
      {
        name: "keywords",
        content: "Exhibition,Brand Promotion,Pop show,Showroom,Immersive,Interactive-Product,Digital Space,Spatial Interaction,Digital Art,Interactive Space,Interactive Technology,Scenes,Arts,Space Operations,AI Interaction,installation,AIGC/MR/AR,VR"
      },
      {
        name: "description",
        content: "U-Cute Lab founded in 2020, it is an interdisciplinary team that is constantly committed to exploring the feasibility of the integration and application of art and technology in interactive space"
      },
    ],
  }
}
</script>

<style scoped lang="scss">
</style>
